import './App.css';
import AppProvider from './context/AppProvider';
import Container from './page/container/Container'
import Load from './page/load/Load'

const App = () => {

    return (
        <AppProvider>
            <div className="App">
                <Load />
                <Container />
            </div>
        </AppProvider>
    )
}

export default App;
